
import {
  computed, defineComponent, PropType, onMounted,
} from 'vue-demi';
import { getCountryCodeForRegionCode, parsePhoneNumber } from 'awesome-phonenumber';
import AdmTextField from '../AdmTextField';
import countries from './countries';
import './phone.scss';

export default defineComponent({
  name: 'adm-phone',
  components: {
    AdmTextField,
  },
  emits: ['update:modelValue'],
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    defaultCountry: {
      type: String,
      default: '',
    },
    modelValue: {
      type: String,
      default: '',
    },
    size: {
      type: String as PropType<'small' | 'normal'>,
      default: 'normal',
    },
    dense: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    helperText: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const value = computed({
      get() {
        const { number } = parsePhoneNumber(props.modelValue);

        if (!number) {
          return '';
        }

        return number.international || number.input;
      },
      set(nextValue) {
        const phoneValue = nextValue.indexOf('+') !== -1 ? nextValue : `+${nextValue}`;
        const { number } = parsePhoneNumber(phoneValue);
        const parserNumber = number ? (number.e164 || number.input) : '';

        emit('update:modelValue', nextValue ? parserNumber : '');
      },
    });

    const countryCode = computed(() => parsePhoneNumber(`${value.value} `).regionCode);

    const selectedCode = computed(() => {
      const flagCode = countryCode.value || props.defaultCountry;
      const country = countries.find(({ code }) => code === flagCode);

      return country ? country.emoji : '';
    });

    onMounted(() => {
      if (props.defaultCountry && !props.modelValue) {
        const dialCode = getCountryCodeForRegionCode(props.defaultCountry);

        emit('update:modelValue', `+${dialCode} `);
      }
    });

    const onCodeChange = (code: string) => {
      if (code) {
        value.value = code;
      }
    };

    const isNumber = (event: KeyboardEvent): void => {
      const keysAllowed: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      const keyPressed: string = event.key;

      if (keyPressed === '+' && value.value === '') {
        return;
      }

      if (!keysAllowed.includes(keyPressed)) {
        event.preventDefault();
      }
    };

    return {
      value,
      selectedCode,
      countries,
      onCodeChange,
      isNumber,
    };
  },
});
